import { render, staticRenderFns } from "./ProjectShow.vue?vue&type=template&id=ee9be77c&scoped=true&"
import script from "./ProjectShow.vue?vue&type=script&lang=ts&"
export * from "./ProjectShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9be77c",
  null
  
)

export default component.exports